import React, { useState } from 'react';
import {
    Button,
    CircularProgress
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
    sendSupportEmail
} from 'actions/account';
import AppHelper from 'helpers/AppHelper';
import UploadMedia from 'components/Base/UploadMedia';
import useStyles from './styles';
import LabelInput from 'components/Base/LabelInput';
import LabelTextArea from 'components/Base/LabelTextArea';

const SupportEmail = (props: any) => {
    const styles = useStyles();
    const dispatch = useDispatch();
    const { params } = props;
    const [media, setMedia] = useState<any>(null);
    const { loadingSendSupportEmail, profile } = useSelector((state: any) => state.account);
    const {
        getValues,
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({ mode: 'onSubmit' });

    const handleCreateFormBrik = async () => {
        const params: any = {
            subject: getValues('supportSubject'),
            description: getValues('supportBrikDesc'),
            source: 'app_owner',
            email: profile?.email
        };
        if (media) {
            params.file = media;
        }
        await dispatch(sendSupportEmail(params));
        AppHelper.hideGlobalModal();
    };

    const onChangeImageExercise = (media: any, thumbnailImage: any) => {
        setMedia(media);
    };
    

    return (
        <div className={styles.container}>
            <div className={styles.title}>{params?.title ? params?.title : "Report a bug"}</div>
            <LabelInput
              name='supportSubject'
              label={`What’s the issue?`}
              customClass={styles.inputName}
              required={'Subject is required'}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setValue('supportSubject', event.target.value);
              }}
              register={register}
              maxLength={50}
              errors={errors}
              showErrors
            />
            <LabelTextArea
              name='supportBrikDesc'
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                setValue('supportBrikDesc', event.target.value);
              }}
              label={params?.descriptionTitle ? params?.descriptionTitle : "What did you expect to happen?" }
              customClass={styles.customTextArea}
              required={'Description is required'}
              maxLength={150}
              register={register}
              errors={errors}
              showErrors
            />
            <UploadMedia
                label=''
                mediaUrl={null}
                thumbNail={null}
                placeholder={<div className={styles.uploadContainer}>
                    <div className={styles.uploadTxtHeader}>Drag or click to upload video or image</div>
                    <div className={styles.uploadText}>Please help us better by providing an image or video of your issue.</div>
                    <div className={styles.uploadText}>Must be under 10 MB</div>
                </div>}
                onChangeImage={onChangeImageExercise}
                customClass={styles.selectAppIcon}
                customUpload={styles.uploadImage}
                onlyAcceptType={["video/mp4","image/png", "image/jpg", "image/jpeg", "image/tiff", "image/gif"]}
            />
            <div className={styles.submitButton}>
                <Button
                    variant='contained'
                    disabled={loadingSendSupportEmail}
                    onClick={handleSubmit(handleCreateFormBrik)}
                >
                    Submit
                    {loadingSendSupportEmail && (
                        <span className={styles.iconLoading}>
                            <CircularProgress size={16} />
                        </span>
                    )}
                </Button>
            </div>
        </div>
    );
}

export default SupportEmail;